/**
 * Keeping these hooks in App would rerender App whnever the hooks are.
 * This handles that issue.
 */
import AdminHooks from './AdminHooks';
import useAnchorLink from './hooks/useAnchorLink';

const HooksIsolator: React.FC<{ isMynewsdeskAdmin?: boolean }> = ({ isMynewsdeskAdmin }) => {
  useAnchorLink();

  return isMynewsdeskAdmin ? <AdminHooks /> : null;
};

export default HooksIsolator;
